document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.hd-mobile-menu');
  if (!menu) return;

  // Dawn hamburger button
  const hamburger = document.querySelector('.header__icon--menu');

  const closeBtn = menu.querySelector('.hd-mobile-close');
  const overlay = menu.querySelector('.hd-mobile-overlay');
  const drawer = menu.querySelector('.hd-mobile-drawer');

  let lastFocused = null;

  function getFocusable() {
    return drawer.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function openMenu(e) {
    if (e) e.preventDefault();

    lastFocused = document.activeElement;

    menu.classList.add('is-open');
    menu.removeAttribute('inert');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');

    // Move focus into the drawer
    closeBtn.focus();
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    menu.setAttribute('inert', '');
    document.body.style.overflow = '';

    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');

    // Return focus to the trigger that opened the menu
    if (lastFocused) lastFocused.focus();
  }

  if (hamburger) {
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.addEventListener('click', openMenu);
  }

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  // Close when a link inside the menu is clicked
  menu.querySelectorAll('.hd-mobile-link, .hd-mobile-top-link').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  // ESC key + focus trap
  document.addEventListener('keydown', (e) => {
    if (!menu.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeMenu();
      return;
    }

    if (e.key === 'Tab') {
      const focusable = getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // Auto-close if the viewport grows past the mobile breakpoint
  const desktopQuery = window.matchMedia('(min-width: 1200px)');
  desktopQuery.addEventListener('change', (e) => {
    if (e.matches && menu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // Accordion
  menu.querySelectorAll('.hd-mobile-dropdown').forEach((button) => {

    button.addEventListener('click', function () {

      const submenu = this.nextElementSibling;
      const isOpen = this.classList.contains('active');

      // Close all
      menu.querySelectorAll('.hd-mobile-dropdown').forEach((btn) => {
        btn.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
      });

      menu.querySelectorAll('.hd-mobile-submenu').forEach((sub) => {
        sub.style.maxHeight = null;
      });

      // Open clicked
      if (!isOpen) {
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
      }

    });

  });

});